export const PAGINATION_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_NUMBER = 1;
export const ERROR_MESSAGE = "Something went wrong. Please try again later.";
export const DOWNLOAD_FILE_ERROR = "Failed to download file.";
export const SHORT_CASHING = 5 * 60 * 1000;
